'use client';

import { ErrorBoundary } from 'react-error-boundary';
import logger from '@/utils/client-logger';

interface PaymentErrorFallbackProps {
  error: Error;
  paymentType: string;
}

/**
 * 支付方式错误回退组件
 * 当支付组件出现错误时显示此组件
 */
function PaymentErrorFallback({ error, paymentType }: PaymentErrorFallbackProps) {
  // 记录错误日志
  if (typeof window !== 'undefined') {
    logger.error(`${paymentType} 支付组件错误:`, error);
  }

  // 返回 null，不显示任何内容，让组件静默失败
  return null;
}

interface PaymentErrorBoundaryProps {
  children: React.ReactNode;
  paymentType: string; // 支付方式类型，用于错误日志
}

/**
 * 支付方式错误边界组件
 * 用于捕获支付组件的错误，防止页面崩溃
 */
export default function PaymentErrorBoundary({ children, paymentType }: PaymentErrorBoundaryProps) {
  return (
    <ErrorBoundary
      FallbackComponent={({ error }) => (
        <PaymentErrorFallback error={error as Error} paymentType={paymentType} />
      )}
    >
      {children}
    </ErrorBoundary>
  );
}
